import PropTypes from 'prop-types'
import React from 'react'

import StarRating from '../../pages/search/result/starRating'
import MetaCategories from '../../pages/search/result/metaCategories'
import TrendingSash from './common/trendingSash'
import MagnifierConfigurator from '../magnifier/configurator'
import Overlay from '../overlay'
import BarChartIcon from '../icons/barChart'
import ItemActions from './common/itemActions'

const screenshotSrc = item =>
  `https://envato-screenshots.imgix.net/${
    item.id
  }/screenshot.jpeg?w=300&h=280&fit=crop&crop=top`

const marketingSrc = item =>
  (item.previews.landscape_preview &&
    item.previews.landscape_preview.landscape_url) ||
  (item.previews.icon_with_video_preview &&
    item.previews.icon_with_video_preview.landscape_url)

const ItemListViewImage = ({ item, src }) => {
  return (
    <img
      alt={item.name}
      className="preload no_preview landscape-image-magnifier"
      src={src}
      title={item.name}
      onError={e => {
        e.target.src = marketingSrc(item)
      }}
    />
  )
}

const ItemListViewScreenshotImage = ({ item }) => (
  <ItemListViewImage item={item} src={screenshotSrc(item)} />
)

const ItemListViewMarketingImage = ({ item }) => (
  <ItemListViewImage item={item} src={marketingSrc(item)} />
)

const ItemCardListDefault = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {},
  muted,
  muteVideo,
  imageType
}) => {
  const thumbnailClass = `item-thumbnail__image item-thumbnail__${imageType ||
    'screenshot'}`

  return (
    <div>
      <div className="product-list__columns-container">
        <div className="product-list__column-detail">
          <div className="product-list__item-thumbnail">
            <div className="item-thumbnail">
              <Overlay
                position="side"
                content={
                  <MagnifierConfigurator
                    item={item}
                    videoMuted={muted}
                    muteVideo={muteVideo}
                  />
                }
              >
                <div className={thumbnailClass}>
                  <a
                    href={`${item.url}?s_rank=${rank}`}
                    onClick={onItemLinkClick}
                    className="item-thumbnail__link"
                  >
                    {imageType === 'marketing' ? (
                      <ItemListViewMarketingImage item={item} />
                    ) : (
                      <ItemListViewScreenshotImage item={item} />
                    )}
                  </a>
                  {item.previews.live_site ? (
                    <div className="item-thumbnail__preview">
                      <a
                        href={item.previews.live_site.url}
                        target="_blank"
                        className="item-thumbnail__preview-link"
                      >
                        Live preview
                      </a>
                    </div>
                  ) : null}
                </div>
              </Overlay>
            </div>
          </div>

          <div className="product-list__adjacent-thumbnail">
            <h3 className="product-list__heading">
              <a
                className="fds-c-text-link -color-inherit -decoration-reversed"
                href={`${item.url}?s_rank=${rank}`}
                onClick={onItemLinkClick}
              >
                {item.name}
              </a>
            </h3>

            <div className="product-list__price">
              <p className="fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0">
                ${item.ui.price}
              </p>
            </div>

            <div className="product-list__info">
              <div className="product-list__info-author">
                <a
                  className="fds-c-text-link -color-default -decoration-reversed"
                  href={item.author_url}
                >
                  {item.author_username}
                </a>
              </div>

              <div className="product-list__column-category">
                <p className="fds-c-text-body -size-xs fds-u-m0">
                  <MetaCategories
                    classification={item.classification}
                    className="meta-categories -no-slash"
                  />
                </p>
              </div>

              <div className="product-list__info-rating">
                {item.rating.rating ? (
                  <StarRating
                    rating={item.rating.rating}
                    className="star-rating--search"
                  />
                ) : null}
                {item.rating.rating && item.rating.count
                  ? `${item.rating.count} ratings`
                  : null}
              </div>

              {item.number_of_sales ? (
                <div className="product-list__info-sale">
                  <span className="product-list__info-sale-glyph">
                    <BarChartIcon />
                  </span>
                  {item.number_of_sales} Sales
                </div>
              ) : null}

              <div className="product-list__item-thumbnail-actions">
                <div className="item-thumbnail-actions -width-full">
                  <ItemActions
                    item={item}
                    onAddToFavourites={onAddToFavourites}
                    onAddToCollections={onAddToCollections}
                    onAddToCart={onAddToCart}
                    nonAudioTheme
                    transparentTheme
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="product-list__column-price">
          <p className="product-list__price-desktop">${item.ui.price}</p>
          <div className="product-list__info-desktop">
            {item.rating.rating ? (
              <StarRating
                rating={item.rating.rating}
                className="star-rating--search"
              />
            ) : null}
            {item.rating.rating ? <br /> : null}
            {item.rating.rating && item.rating.count
              ? `${item.rating.count} ratings`
              : null}
            {item.number_of_sales ? (
              <div className="product-list__sales-desktop">
                <BarChartIcon width="20" height="30" />
                <br />
                {item.number_of_sales ? `${item.number_of_sales} Sales` : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {item.trending && <TrendingSash />}
    </div>
  )
}

ItemCardListDefault.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToFavourites: PropTypes.func.isRequired,
  rank: PropTypes.number.isRequired,
  onItemLinkClick: PropTypes.func,
  onAddToCart: PropTypes.func,
  imageType: PropTypes.string
}

export default ItemCardListDefault



// WEBPACK FOOTER //
// ./client/components/itemCard/listDefault.v1.js